
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useAuth } from '@/providers/AuthProvider';

/**
 * Hook to update Sentry user context when authentication state changes
 * This improves release health monitoring by tracking user adoption and user-specific errors
 */
export function useSentryUser() {
  const { user, session } = useAuth();
  
  useEffect(() => {
    if (user) {
      // Set the user context in Sentry when a user is authenticated
      Sentry.setUser({
        id: user.id,
        email: user.email || undefined, // Only set if available
        username: user.user_metadata?.username || undefined,
        role: user.role || undefined
      });
      
      // Add any relevant tags for this user session
      Sentry.setTag('auth_provider', user.app_metadata?.provider || 'unknown');
      Sentry.setTag('has_email_verified', user.email_confirmed_at ? 'true' : 'false');
    } else {
      // Clear the user context when logged out
      Sentry.setUser(null);
      
      // Also clear any user-specific tags
      Sentry.setTag('auth_provider', null);
      Sentry.setTag('has_email_verified', null);
    }
  }, [user]);
  
  return { user };
}
